"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _ImageBarTemplate = require("./ImageBarTemplate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledCheck = _styledComponents.default.span.withConfig({
  displayName: "StyledCheck"
})(["height:16px;min-width:16px;border-radius:10px;margin:auto 1.6vw;border:", ";border-color:", ";box-sizing:border-box;"], function (_ref) {
  var checked = _ref.checked;
  return checked ? '5px solid' : '1.2px solid';
}, function (_ref2) {
  var checked = _ref2.checked,
      theme = _ref2.theme;
  return checked ? theme.brand.secondary : theme.ui.outline;
});

var RadioOption = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var checked = _ref3.checked,
      disabled = _ref3.disabled,
      name = _ref3.name,
      handleChange = _ref3.handleChange,
      icon = _ref3.icon,
      children = _ref3.children,
      className = _ref3.className,
      otherProps = _objectWithoutProperties(_ref3, ["checked", "disabled", "name", "handleChange", "icon", "children", "className"]);

  var onChange = function onChange(e) {
    e.persist();
    handleChange({
      name: e.target.name,
      value: e.target.value
    });
  };

  return /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.Container, {
    checked: checked,
    disabled: disabled,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.StyledInput, _extends({
    type: "radio",
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    name: name,
    ref: ref
  }, otherProps)), icon, /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.Text, null, children), /*#__PURE__*/_react.default.createElement(StyledCheck, {
    checked: checked
  }));
});
RadioOption.displayName = 'RadioOption';
RadioOption.propTypes = {
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string,
  handleChange: _propTypes.default.func,
  icon: _propTypes.default.elementType,
  children: _propTypes.default.node,
  className: _propTypes.string
};
RadioOption.defaultProps = {
  checked: false
};
var _default = RadioOption;
exports.default = _default;